export default function getProductionTeamMembersByRole({ production, role }) {
	return Object.values(production?.team || {})
		.filter((member) => member.role === role)
		.map((member) => {
			const splitName = member?.user?.name?.split(" "); // Fix for offer production team not matching schema currently. No need for the values right now so this fixes the zod validation issue.
			const firstName = splitName?.[0] || "";
			const lastName = splitName?.[1] || "";
			return {
				id: member?.user?.id,
				img: member?.user?.img,
				name: member?.user?.name,
				firstName,
				lastName,
				email: member?.user?.email,
			};
		});
}
